import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'pim-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.sass'],
    standalone: false
})
export class CheckboxComponent {
	@Input()
	checked: boolean = false;

	@Input()
	label: string = '';

	@Input()
	secondLabel: string = '';

	@Input()
	disabled: boolean = false;

	@Output()
	checkboxChanged: EventEmitter<boolean> = new EventEmitter<boolean>();


	toggle(): void {
		if (this.disabled) {
			return;
		}
		this.checked = !this.checked;
		this.checkboxChanged.emit(this.checked);
	}
}
